import React from 'react'
import siteUrl from '../../../utils/siteUrl';
import { graphql, useStaticQuery } from "gatsby";

import './redirect.scss';

const Redirect = props => {
    const { children, url, className, gtm } = props;

    const isExter = url.includes('http');

    const { contentfulInformacionGeneral } = useStaticQuery(
        graphql`{
            contentfulInformacionGeneral{
                textoDeBotonesEnMaysculas
            }
        }`
    );
    const { textoDeBotonesEnMaysculas } = contentfulInformacionGeneral;

    return (
        <a 
          className={ 
              "a-redirect " + (className ? className : '') 
              + ( textoDeBotonesEnMaysculas  ? ' uppercase' : '')
              + ( typeof gtm !== 'undefined' ? ' ' + gtm : '' )
          } 
          href={ isExter ? url : ( url === '/' ) ? siteUrl : `${siteUrl}/${url}${ ( url.length > 0 && url[ url.length - 1 ] !== '/' && !url.includes('?') ) ? '/': '' }` } 
          target={ (isExter && !url.includes('bam.com.gt') ) ? '_blank' : undefined }
          rel={ (isExter && !url.includes('bam.com.gt') ) ? 'noopener noreferrer nofollow' : '' }
        >
            { children }  
        </a>
    )
}

export default Redirect
